import React from 'react';

import { AccountItem } from './_account-item';
import { Colors } from 'works/legacy/lib/style-helper';
import { Icon, IconOfKind } from '@common/components';

export const LinkOption = ({
  onClick,
  icon,
  children,
}: {
  onClick: () => void;
  icon: IconOfKind;
  children: string;
}) => (
  <div className="link-option">
    <AccountItem onClick={onClick}>
      <div className="body-medium">
        <Icon size="sm" {...icon} />
      </div>
      <div className="body-medium">{children}</div>
    </AccountItem>
    <style jsx>{`
      .link-option {
        padding-bottom: 8px;
        padding-left: 8px;
        padding-right: 8px;
      }
      .link-option:hover {
        color: ${Colors.elm};
      }
      .link-option :global(svg) {
        width: 17px;
        height: 100%;
      }
      .link-option :global(.body-medium) {
        line-height: 20px;
      }
    `}</style>
  </div>
);
